import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locale/en/translation.json";
import es from "./locale/es/translation.json";

export const defaultNS = "translation";
export const supportedLanguages = ["en", "es"] as const;
export type LanguageCode = (typeof supportedLanguages)[number];

export const resources = {
  en: { translation: en },
  es: { translation: es },
} as const;

const storedLang =
  typeof localStorage !== "undefined" ? localStorage.getItem("ui-lang") : null;
const browserLang =
  typeof navigator !== "undefined" ? navigator.language?.slice(0, 2) : "en";

i18n.use(initReactI18next).init({
  resources,
  lng: storedLang || browserLang,
  fallbackLng: "en",
  ns: [defaultNS],
  defaultNS,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

// Exported so any module can call `t("...")` without the React hook.
export const t = i18n.getFixedT<"translation", string>(defaultNS);

export default i18n;
